var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.00568C16.8631 1.00568 19.1294 1.94441 20.8003 3.61535C22.4713 5.2863 23.41 7.5526 23.41 9.91568C23.41 19.8226 27.0238 21.7749 28 21.7749H1C1.99692 21.7749 5.59 19.8018 5.59 9.91568C5.59 7.5526 6.52873 5.2863 8.19968 3.61535C9.87063 1.94441 12.1369 1.00568 14.5 1.00568V1.00568Z",
    stroke: "#000001",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3845 25.5757C11.5641 26.2653 11.9673 26.8759 12.5311 27.3117C13.0949 27.7475 13.7873 27.9839 14.4999 27.9839C15.2125 27.9839 15.9049 27.7475 16.4687 27.3117C17.0325 26.8759 17.4358 26.2653 17.6153 25.5757",
    stroke: "#000001",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.32260869c48355f4ec5fc8ca4ab6b0b7.svg";
export { ForwardRef as ReactComponent };